export const LOGIN_REASON_PARAM = 'reason';
export const SESSION_EXPIRED_REASON = 'session_expired';

export function isSessionExpired(reason: string | null): boolean {
  return reason === SESSION_EXPIRED_REASON;
}
